import { Injectable } from "@angular/core";
import { CreateCertifiedPlantMutation, CreatePlantDeviceInput, CreatePlantEmsInput, CreatePlantUserInput, CreatePlantUserPrefInput, PlantConfigInput, PlantGeoInput } from "ngx-core-services";

import { fragment } from "./create-aws-query";

@Injectable({
  providedIn: 'root'
})
export class CreateAwsService {
  constructor(private readonly createCertifiedPlantMutation: CreateCertifiedPlantMutation) { }

  async createAwsPlant(
    devices: CreatePlantDeviceInput[],
    geo: PlantGeoInput,
    users: CreatePlantUserInput[],
    plantUserPrefs: CreatePlantUserPrefInput,
    config: PlantConfigInput,
    ems?: CreatePlantEmsInput
  ) {
    const result = await this.createCertifiedPlantMutation.execute(fragment , {
      plant: {
        devices,
        geo,
        ems,
        users,
        plantUserPrefs,
        config,
      }
    });

    if( result.data?.createCertifiedPlant.message ) {
      throw new Error(result.data?.createCertifiedPlant.message);
    }

    return result.data?.createCertifiedPlant;
  }
}